const KILLSHOT_GETTING_HEADLINER = 'KILLSHOT_GETTING_HEADLINER';
const KILLSHOT_GETTING_HEADLINER_SUCCESS = 'KILLSHOT_GETTING_HEADLINER_SUCCESS';
const KILLSHOT_GETTING_USERS = 'KILLSHOT_GETTING_USERS';
const KILLSHOT_GETTING_USERS_SUCCESS = 'KILLSHOT_GETTING_USERS_SUCCESS';
const KILLSHOT_GETTING_ASSIGNEES_SUCCESS = 'KILLSHOT_GETTING_ASSIGNEES_SUCCESS';
const KILLSHOT_GETTING_TAGS = 'KILLSHOT_GETTING_TAGS';
const KILLSHOT_GETTING_TAGS_SUCCESS = 'KILLSHOT_GETTING_TAGS_SUCCESS';
const initialState = {
  headliners: [],
  headlinersLoading: true,
  pricersLoading: true,
  tagsLoading: true,
  pricers: [],
  assignees: [],
  tags: [],
};

const killshot = (state = initialState, action) => {
  switch (action.type) {
    case KILLSHOT_GETTING_HEADLINER:
      return {
        ...state,
        headlinersLoading: action.payload,
      };
    case KILLSHOT_GETTING_HEADLINER_SUCCESS:
      return {
        ...state,
        headliners: action.payload,
      };
    case KILLSHOT_GETTING_USERS:
      return {
        ...state,
        pricersLoading: action.payload,
      };
    case KILLSHOT_GETTING_USERS_SUCCESS:
      return {
        ...state,
        pricers: action.payload,
      };
    case KILLSHOT_GETTING_ASSIGNEES_SUCCESS:
      return {
        ...state,
        assignees: action.payload,
      };
    case KILLSHOT_GETTING_TAGS:
      return {
        ...state,
        tagsLoading: action.payload,
      };
    case KILLSHOT_GETTING_TAGS_SUCCESS:
      return {
        ...state,
        tags: action.payload,
      };
    default:
      return state;
  }
};

export default killshot;
